<!-- 上传进度弹窗 -->
<script setup lang="ts">
const props = defineProps<{
  open: boolean
  status: string
  progress: number
}>()

const emit = defineEmits<{
  (e: 'update:open', value: boolean): void
  (e: 'cancel'): void
}>()

// 标记是否允许关闭（只有通过 Cancel 按钮才能关闭）
const allowClose = ref(false)

const modalOpen = computed({
  get: () => props.open,
  set: (value) => {
    // 如果尝试关闭弹窗，但未允许关闭，则阻止关闭
    if (!value && !allowClose.value) {
      return
    }
    // 如果允许关闭，重置标记并发出事件
    if (!value && allowClose.value) {
      allowClose.value = false
    }
    emit('update:open', value)
  }
})

const handleCancel = () => {
  // 允许关闭，然后关闭弹窗
  allowClose.value = true
  emit('cancel')
  modalOpen.value = false
}
</script>

<template>
  <UModal
    v-model:open="modalOpen"
    :dismissible="false"
    :ui="{
      overlay: 'bg-[#101012B2] backdrop-blur-[3px]',
      content: 'w-[min(620px,92vw)] bg-[#2D2D39] rounded-[16px] ring-[none]'
    }"
  >
    <template #content>
      <div class="flex flex-col gap-y-[32px] w-full h-full font-['Roboto'] p-6">
        <div class="text-[22px] text-white leading-[28px]">
          Uploading...
        </div>
        <div class="flex items-center justify-between gap-x-[32px]">
          <div class="w-full h-[16px] rounded-full bg-[#5E5E77] overflow-hidden">
            <div
              class="h-full rounded-full bg-[#BF2AFF] transition-all duration-300 ease-out"
              :style="{ width: `${props.progress}%` }"
            />
          </div>
          <button
            class="text-[14px] text-white leading-[20px] px-[16px] py-[12px] rounded-[8px] border border-[#8888A1] transition-colors cursor-pointer"
            @click="handleCancel"
          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </UModal>
</template>
